module.exports = __webpack_public_path__ + "assets/images/iw-logo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/iw-logo.svg
// module id = 616
// module chunks = 0